module.exports = __webpack_public_path__ + "media/images/logo-white-notext-db2f6255ac96544dc30b55da55f5ef70.png";